import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import { icons } from "../../../assets/icons";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const DatePicker = ({
  title = "",
  wrapperClassName = "",
  datePickerClassName = "",
  datePickerTextClassName = "",
  required = false,
  labelClassName = "",
  dateRange = false,
  startDate = new Date(),
  endDate,
  onChange,
  error,
  minDate,
  maxDate,
  disabled = false,
}) => {
  const dateFormat = "DD MMM yyyy";
  const dateToShow =
    startDate && !endDate
      ? moment(startDate).format(dateFormat)
      : startDate && endDate
      ? `${moment(startDate).format(dateFormat)} - ${moment(endDate).format(dateFormat)}`
      : "";

  const CustomPicker = forwardRef(({ value, onClick }, ref) => (
    <div
      className={`flex justify-between items-center w-[100%] h-[5rem] border-[1px] border-[var(--borderGray1)] pl-3 pr-5 rounded-[0.4rem] cursor-pointer ${datePickerClassName}`}
      onClick={onClick}
      ref={ref}
    >
      <div className={`font-size-small ${datePickerTextClassName}`}>
        {dateToShow}
      </div>
      <img
        src={icons.calendarIcon}
        alt="calendar icon"
        className="h-[2.2rem] w-[2.2rem] ml-3"
      />
    </div>
  ));

  return (
    <div className={`bg-[var(--whiteColor)] ${wrapperClassName}`}>
      {title ? (
        <div
          className={`font-size-small text-[var(--blackColor)] mb-2 ${labelClassName}`}
        >
          {title}
          {required ? <span className="text-[#e55353]"> *</span> : null}
        </div>
      ) : null}

      <ReactDatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange={dateRange}
        customInput={<CustomPicker />}
        minDate={minDate}
        maxDate={maxDate}
        monthsShown={dateRange ? 2 : 1}
        disabled={disabled}
      />
      {error ? (
        <div className={`font-size-small text-[var(--textRed)] mt-2`}>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default DatePicker;
